import React, { Component } from 'react';
import { connect } from 'react-redux';
import '../risk_profile_table.css';

class RiskProfileTable extends Component {
  render() {
    const profiles = this.props.profile.profiles;
    const likelihood_header = this.props.profile.header.likelihood_header;
    const ratings_header = this.props.profile.header.ratings_header;

    return (
      <table>
        <thead>
          <tr>
            <th rowSpan="2" colSpan="2" className="background-white likelihood-header">{likelihood_header.title.toUpperCase()}</th>
          </tr>
          <tr>
            {
              ratings_header && ratings_header.map((obj, i) => {
                return <th className="background-white likelihood-header">{obj.title}</th>
              })
            }
          </tr>
        </thead>
        <tbody>
        { profiles && profiles.map((obj, i)=>{
          var row_index = i + 1
          return (
            <tr key={row_index}>
              <td className="background-white">{obj.likelihood.type}</td>
              <td className="background-white likelihood-description">{obj.likelihood.description}</td>
              { obj.ratings.map((item, j)=>{
                var col_index = j + 1;
                return (
                  <td key={row_index + "-" + col_index} className={ "ratings " + item.class }>
                    <div className="rating">{item.risk_rating}</div>
                    <div className="rating">({item.risk_level})</div>
                    <div className="risk-count-div">
                      <div className="risk-label">{item.current_rating_label}: </div>
                      <div><span className="risk-count">{item.current_rating_count}</span></div>
                    </div>
                  </td>
                )
              })
              }
            </tr>
          )
        })
        }
        </tbody>
      </table>
    )
  }
}

const mapStateToProps = (state) => {
  return {
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RiskProfileTable);



// WEBPACK FOOTER //
// ./src/components/risk_profile_table.js